<template>
  <div class="wrapper">
    <Tabs
      v-if="!isCompanyDetailsPage"
      v-model="activeTab"
      @input="changeTab"
      class="empty-tab"
    >
      <Tab
        :key="`tab-${index}`"
        v-for="(item, index) of authorizedTabs"
        :header="item.label"
      >
      </Tab>
    </Tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import { mapState } from "vuex";

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Entreprises",
          name: "companies-list",
          requiredPermission: "COMPANIES_COMPANY_READ",
        },
        {
          label: "Marchés publics",
          name: "public-procurements-list",
          requiredPermission: "PUBLIC_PROCUREMENTS_READ",
        },
        {
          label: "Émargement",
          name: "signature-sheets",
          requiredPermission: [
            "PUBLIC_PROCUREMENTS_READ",
            "COMPANIES_COMPANY_READ",
          ],
          children: [
            "signature-sheets-list",
            "signature-sheets-templates",
            "sessions-batches",
          ],
        },
      ],
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return Array.isArray(tab.requiredPermission)
          ? tab.requiredPermission.some((permission) =>
              this.hasPermission(this.$store.state.user, permission)
            )
          : this.hasPermission(this.$store.state.user, tab.requiredPermission);
      });
    },

    isCompanyDetailsPage() {
      return (
        this.$route.name === "company-details" ||
        this.$route.name === "public-procurement-details"
      );
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) => tab.name === currentPath || tab.children?.includes(currentPath)
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>

<style lang="scss">
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  & > .tab-content {
    display: none;
  }
}

.display-tab {
  .tab-content {
    display: block !important;
  }
}
</style>
